import React from 'react';
import ErrorIcon from '@material-ui/icons/Error';
import * as warningType from '../flightDetail/warningTypes'


//class BagMtow extends Component {
const warningMessage = (props) => {

  // declare inbound bag amount, outbound bag amount and mtow number            
  let {flightDetail, warningState, warningList } = props

  function warningMessage(){
    if (warningList.length > 0) {
      return warningList.map((warning, i) => {
          return (<div key={flightDetail.LegHashKeyOutbound + i}>{warning.Message} </div>)
      })
    } 
    return ''
  }


  return (
    <div className={`warningMessage ${warningState}`} >
      <div>
    {warningMessage()}
    </div>
    </div>
  );
}

export default warningMessage